export const deMaritalStatusOptions = [
  { value: "single", description: "Single" },
  { value: "married", description: "Married" },
  { value: "divorced", description: "Divorced" },
  { value: "widowed", description: "Widowed" },
  { value: "registered_partnership", description: "Registered Partnership" },
];

export const deReligionOptions = [
  { value: "christian", description: "Christian" },
  { value: "evangelian", description: "Evangelian" },
  { value: "others", description: "Others" },
];

export const deHealthInsuranceStatusOptions = [
  { value: "mandatory", description: "pflichtversichert (mandatory)" },
  { value: "voluntary", description: "freiwillig versichert (voluntary)" },
  { value: "family", description: "familienversichert (family-insured)" },
];

export const deSchoolDegreeOptions = [
  { value: "no_degree", description: "Kein Abschluss (No Degree)" },
  {
    value: "lower_secondary",
    description: "Hauptschulabschluss (Lower Secondary School Certificate)",
  },
  {
    value: "intermediate_secondary",
    description:
      "Realschulabschluss (Intermediate Secondary School Certificate)",
  },
  {
    value: "fachabitur",
    description:
      "Fachhochschulreife (Fachabitur) (Entrance Qualification for Universities of Applied Sciences)",
  },
  {
    value: "abitur",
    description:
      "Allgemeine Hochschulreife (Abitur) (General University Entrance Qualification)",
  },
  {
    value: "international_baccalaureate",
    description: "Internationales Abitur (International Baccalaureate)",
  },
  {
    value: "foreign",
    description: "Ausländischer Schulabschluss (Foreign School Degree)",
  },
  { value: "other", description: "Sonstiger Abschluss (Other Degree)" },
];

export const deProfessionalQualificationOptions = [
  {
    value: "no_qualification",
    description: "Kein Berufsabschluss (No Professional Qualification)",
  },
  {
    value: "vocational_training",
    description:
      "Abgeschlossene Berufsausbildung (Completed Vocational Training)",
  },
  { value: "master_craftsman", description: "Meister (Master Craftsman)" },
  {
    value: "technician",
    description: "Technikerabschluss (Technician Certification)",
  },
  { value: "bachelor", description: "Bachelor-Abschluss (Bachelor's Degree)" },
  { value: "master", description: "Master-Abschluss (Master's Degree)" },
  { value: "doctorate", description: "Promotion (Doctorate)" },
  {
    value: "educator",
    description: "Staatlich anerkannter Erzieher (State-Certified Educator)",
  },
  {
    value: "nurse",
    description:
      "Staatlich anerkannter Gesundheits- und Krankenpfleger (State-Certified Nurse)",
  },
  {
    value: "foreign",
    description:
      "Ausländischer Berufsabschlus (Foreign Professional Qualification)",
  },
  { value: "other", description: "Sonstiger Abschluss (Other Qualification)" },
];

export const deTaxClassOptions = [
  {
    value: "class_1",
    description:
      "Class I – Single, divorced, or widowed (after 2nd year), no children",
  },
  {
    value: "class_2",
    description: "Class II – Single parent with at least one child",
  },
  {
    value: "class_3",
    description: "Class III – Married, spouse in Class V, higher income",
  },
  {
    value: "class_4",
    description: "Class IV – Married, both spouses earn similar income",
  },
  {
    value: "class_4_with_factor",
    description:
      "Class IV with Factor – Married, both earn, factor method for more accuracy",
  },
  {
    value: "class_5",
    description: "Class V – Married, spouse in Class III, lower income",
  },
  {
    value: "class_6",
    description: "Class VI – Second or additional job(s), no allowances",
  },
];
